const NODE_ENV = "";

export const baseUrl =
  NODE_ENV === "development"
    ? "http://localhost:8000/api"
    : "https://positivepromotionsapi.addnectarstudio.com/api";


export const SUPER_ADMIN = 1;
export const ADMIN = 2;
export const ADDNECTAR_ADMIN = 3;
export const COMPANY_USER = 4;
export const COMPANY_MANAGER = 5;
export const ADDNECTAR_ARTIST = 6;
export const ADDNECTAR_MANAGER = 7;
export const ADDNECTAR_ACCOUNT_MANAGER = 8;
export const QC = 9;
export const PAGE = 1;
export const ACCOUNT_LIMIT = 10;
export const COMPANY_LIMIT = 10;
export const PROCESS_LIMIT = 10;
export const STAGE_LIMIT = 10;
export const JOB_LIMIT = 10;
export const SMTPCONFIG_LIMIT = 10;

export const roles = [
  { id: 2, name: 'ADMIN' },
  { id: 3, name: 'ADDNECTAR_ADMIN' },
  { id: 4, name: 'COMPANY_USER' },
  { id: 5, name: 'COMPANY_MANAGER' },
  { id: 6, name: 'ADDNECTAR_ARTIST' },
  { id: 7, name: 'ADDNECTAR_MANAGER' },
  { id: 8, name: 'ADDNECTAR_ACCOUNT_MANAGER' },
  { id: 9, name: 'QC' },
];

export const ADMIN_PORTAL_ACCESS = [
  SUPER_ADMIN,
  ADDNECTAR_ADMIN,
  ADDNECTAR_MANAGER,
  ADMIN,
  COMPANY_MANAGER
]
